import React, { useEffect, useRef, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Icon, ButtonV2 } from 'components';
import './style.scss';

function Softlock({ data = {}, currentSchool, history, onClose, syncSetting }) {
  const shouldRedirectRef = useRef(true);
  const isAdmin = data?.isAdmin;

  const handleUpgrade = useCallback(() => {
    if (currentSchool?.online_subscription) {
      shouldRedirectRef.current = false;
      history.push('/dashboard/subscription');
    } else {
      Actions.showFlash('Please contact our support to upgrade', 'alert');
    }

    onClose?.();
  }, [currentSchool, history, onClose]);

  useEffect(() => {
    return () => {
      if (data.shouldStay) return;
      if (shouldRedirectRef.current) {
        history.push('/');
      }
    };
  }, [data.shouldStay, history]);

  /* ADMIN VIEW */
  if (isAdmin) {
    /* STRIPE MODAL */
    if (currentSchool.billing_gateway === 'stripe') {
      return (
        <div className="softlock">
          <div className="softlock__background">
            <div className="softlock__background-top" />
            <div className="softlock__background-bottom" />
          </div>

          <div className="softlock__inner">
            <div className="softlock__header">
              <div className="softlock__lock-icon">
                <Icon name="lock-2" color="#F99E1C" size={52} />
              </div>
              <div className="softlock__title">
                There is an issue with the payment method on file for your Procare account subscription.
              </div>
            </div>

            <div className="softlock__content">
              <div className="softlock__primary-message">
                Your account is currently on hold and some features are temporarily unavailable. Full access will be
                restored once this issue is resolved.
              </div>
              <div className="softlock__message">
                <strong>Reason for On Hold status:</strong>
                <br></br>
                Issue with payment method on file.
              </div>
              <div className="softlock__upgrade-button-wrapper">
                <ButtonV2 className="softlock__upgrade-button" label="Update Payment Method" onClick={handleUpgrade} />
              </div>
              <div className="softlock__contact">
                <div className="softlock__contact-message">
                  If you have questions or need further assistance please contact Procare Support
                </div>
                <div className="softlock__contact-info">
                  <div className="softlock__contact-hours">
                    <strong>Hours: </strong>M-F, 7 am - 8 pm ET
                  </div>
                  <div className="softlock__contact-phone">
                    <strong>Phone: </strong>(800) 964-1729
                  </div>
                  <div className="softlock__contact-email">
                    <strong>Email: </strong>
                    <a href="mailto:support@procaresoftware.com">support@procaresoftware.com</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    /* NETSUITE MODAL */
    if (currentSchool.billing_gateway === 'te') {
      return (
        <div className="softlock">
          <div className="softlock__background">
            <div className="softlock__background-top" />
            <div className="softlock__background-bottom" />
          </div>

          <div className="softlock__inner">
            <div className="softlock__header">
              <div className="softlock__lock-icon">
                <Icon name="lock-2" color="#F99E1C" size={52} />
              </div>
              <div className="softlock__title">
                There is an issue with the payment method on file for your Procare account subscription.
              </div>
            </div>

            <div className="softlock__content">
              <div className="softlock__primary-message">
                Your account is currently on hold and some features are temporarily unavailable. Full access will be
                restored once this issue is resolved.
              </div>
              <div className="softlock__message">
                Please contact Procare Support with the below information to resolve the issue.
              </div>
              <div className="softlock__message">
                <strong>Reason for On Hold status:</strong>
                <br></br>
                Issue with payment method on file.
              </div>
              <div className="softlock__message">
                <strong>Customer IKN: </strong>
                {syncSetting[0]?.procare_ikn}
              </div>
              <div className="softlock__contact">
                <div className="softlock__contact-info alternate">
                  <div className="softlock__contact-heading">Contact Procare Support</div>
                  <div className="softlock__contact-hours">
                    <strong>Hours: </strong>M-F, 7 am - 8 pm ET
                  </div>
                  <div className="softlock__contact-phone">
                    <strong>Phone: </strong>(800) 964-1729
                  </div>
                  <div className="softlock__contact-email">
                    <strong>Email: </strong>
                    <a href="mailto:support@procaresoftware.com">support@procaresoftware.com</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  /* NON-ADMIN VIEW */
  return (
    <div className="softlock">
      <div className="softlock__background">
        <div className="softlock__background-top" />
        <div className="softlock__background-bottom" />
      </div>

      <div className="softlock__inner">
        <div className="softlock__header">
          <div className="softlock__lock-icon">
            <Icon name="lock-2" color="#F99E1C" size={52} />
          </div>

          <div className="softlock__title">Something went wrong with your Procare Account Subscription.</div>
        </div>

        <div className="softlock__content">
          <div className="softlock__primary-message">
            Your account is currently on hold and some features are temporarily unavailable. Full access will be
            restored once this issue is resolved.
          </div>
          <div className="softlock__message">
            To resolve this issue please have your Procare account admin contact our Support team.
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  currentSchool: state.currentUser.data.current_school,
  syncSetting: state.syncPESetting.data
});

export default withRouter(connect(mapStateToProps)(Softlock));
